import { DatePresetRange } from './types';

export const DATE_PRESETS: { label: string; value: DatePresetRange }[] = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'This week', value: 'current_week' },
  { label: 'Last week', value: 'last_week' },
  { label: 'This month', value: 'current_month' },
  { label: 'Last month', value: 'last_month' },
  { label: 'This year', value: 'current_year' },
  { label: 'Last year', value: 'last_year' },
  { label: 'All time', value: 'all_time' },
];
